<template>
  <div class="switchBar">
    <el-tabs
      v-model="activeName"
      type="card"
      class="demo-tabs"
      @tab-click="handleClick"
    >
      <el-tab-pane label="待审核" name="first"></el-tab-pane>
      <el-tab-pane label="通过" name="second"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="id" prop="id" />
      <el-table-column label="用户名" prop="name" />
      <el-table-column label="邮箱" prop="email" />
      <el-table-column label="创建时间" prop="createTime" />
      <el-table-column
        label="备注"
        prop="remark"
        v-if="activeName == 'third'"
      />
      <el-table-column align="right">
        <template #default="scope">
          <el-button
            v-if="activeName == 'first'"
            type="warning"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
            >通过</el-button
          >
          <el-button
            v-if="activeName == 'second'"
            type="danger"
            size="small"
            @click="quash(scope.$index, scope.row)"
            >撤销</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
} from "@element-plus/icons-vue";
import { ElMessageBox, TabsPaneContext } from "element-plus";
import { Form, GameData } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      tableData: [],
      status: 0,
      centerDialogVisible: false,
      form: {
        code: 0,
        createTime: "2024-11-05 17:23:26",
        email: "1172274374@qq.com",
        id: "1853694920275722242",
        name: "匿名用户",
      },
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.gameCover !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {},
  created() {
    this.fetchGameList(this.currentPage, this.status);
  },
  methods: {
    fetchGameList(pageNum: number, status: number) {
      const pageSize = 10;
      this.$store
        .dispatch("game/getApply", { pageNum, pageSize, status })
        .then((res: any) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {});
    },
    handleCurrentChange(val: number) {
      this.fetchGameList(val, this.status);
    },
    handleEdit(index: number, row: Form) {
      this.form = row;
      this.updateApply(row.id, 1);
    },
    handleClick(tab: TabsPaneContext) {
      this.status =
        tab.paneName === "first" ? 0 : tab.paneName === "second" ? 1 : 2;
      this.fetchGameList(1, this.status);
    },
    noPass() {
      ElMessageBox.prompt("请输入失败原因", "Tip", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.updateGame(this.form.id, 2, value);
        })
        .catch(() => {});
    },
    pass() {
      this.updateGame(this.form.id, 1);
    },
    quash(index: number, row: Form) {
      this.updateApply(row.id, 2);
    },
    updateApply(id: string, code: number) {
      this.$store
        .dispatch("game/auditApply", {
          id: id,
          code: code,
        })
        .then((res) => {
          if (res == 1) {
            this.fetchGameList(this.currentPage, this.status);
          }
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
